import React from 'react';
import PopupContainer from '../../../common/components/PopupContainer';
import CustomButton from '../../../common/components/CustomButton';

export default function MusicPermissionToUseListPopup({
  onClose,
} : {
  onClose: () => void,
}) {
  return (
    <PopupContainer title="現在の曲の提供先" onClose={() => { onClose(); }}>
      <div>
        <ul className="table_list">
          <li className="table_title">
            <span>Alexaスキル・インディーズ音楽セレクション（株式会社ワールドスケープ）</span>
          </li>
          <li>
            <p className="tag">概要</p>
            <span>AmaonのスマートスピーカーAmazon Echoシリーズで「インディーズ音楽セレクション」のスキルを有効にすると聴くことができます。毎日更新。</span>
          </li>
          <li>
            <p className="tag">曲利用料</p>
            <span>現状、利用料は分配されません。</span>
          </li>
          <li>
            <p className="tag">宣伝効果</p>
            <span>スキルを実行したリスナーにあなたの曲を知ってもらうことができます。画面付きのデバイスでは、アーティスト名や曲名も紹介されます。</span>
          </li>
        </ul>
        <ul className="table_list">
          <li className="table_title">
            <span>Simple BGM（株式会社ワールドスケープ）</span>
          </li>
          <li>
            <p className="tag">概要</p>
            <span>店舗・オフィス・イベント会場・生配信などで使うことができるBGMアプリです。インスト（歌なし）曲を中心に、BGMとして使いやすい曲が連続再生されます。</span>
          </li>
          <li>
            <p className="tag">曲利用料</p>
            <span>
              前月の実績に応じて、毎月1〜10日の間に曲の利用料が分配されます。
              分配金額は、スモールプラン契約1件あたりの株式会社ワールドスケープが受け取る金額に、全プラン合計契約件数をかけた金額を100%とした時の、23％を再生回数で割ったものと、 2％をSimple BGMに曲を登録しているアーティスト数で割ったものとなります。
            </span>
          </li>
          <li>
            <p className="tag">宣伝効果</p>
            <span>店舗・オフィス・イベント会場の来場者や生配信の配信者・リスナーに知ってもらうことができます（ただし表示は曲名のみ）。</span>
          </li>
        </ul>
        <ul>
          <li className="bt">
            <CustomButton type="cancel" onClick={() => onClose()}>閉じる</CustomButton>
          </li>
        </ul>
      </div>
    </PopupContainer>
  );
}
